import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
import GlobalContext from "../../context/Global";
var ProgressWrapper = function(props) {
    var children = props.children;
    var progressWrapperStyles = useContext(GlobalContext).progressWrapperStyles;
    return /*#__PURE__*/ _jsx("div", {
        style: _object_spread({}, styles.progress, progressWrapperStyles, getProgressWrapperStyle(props)),
        children: children
    });
};
var getProgressWrapperStyle = function(param) {
    var width = param.width;
    return {
        width: "".concat(width * 100, "%")
    };
};
var styles = {
    progress: {
        height: 2,
        maxWidth: "100%",
        background: "rgba(255, 255, 255, 0.8)",
        margin: 2,
        borderRadius: 2,
        WebkitBackfaceVisibility: "hidden",
        MozBackfaceVisibility: "hidden",
        msBackfaceVisibility: "hidden",
        backfaceVisibility: "hidden"
    }
};
export default ProgressWrapper;
